module.exports = __webpack_public_path__ + "img/banner-video.02a87d7c.jpg";